import { UserOrderFlow } from '@imcc/transport';
import { IOrderFormChange } from '../orders/i-order-form';
import { EcommerceEvent } from './ecommerce-event-enum';
import { IOrderCreation } from './i-order-creation';

export function buildOrderCreation(
  formValues: IOrderFormChange,
): IOrderCreation {
  const { purpose } = formValues;

  return {
    event: EcommerceEvent.CheckoutOption,
    ecommerce: {
      checkoutOption: {
        actionField: {
          step: 1,
          option: purpose,
        },
        dimension10: UserOrderFlow.CheckoutFlow,
      },
    },
  };
}
